import session from '@/shared/session'

// initial state
const state = {
	all_movements: {},
	all_movement_types: {},
}

// getters
const getters = {}

const data = {}
// actions
const actions = {
	movementOverview ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/movements/', { params: data,
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				commit('set_movements', data)
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	movementDetail ({},data) {
		return new Promise((resolve, reject) => {
			session.get(`/api/workouts/movements/${data.id}/`, {
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	movementCreate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.post('api/workouts/movements/', data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	movementUpdate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.put(`/api/workouts/movements/${data.id}/`, data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	movementRemove ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/movements/partial_update_delete/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	filterMovements ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/movements/get_filtered_movements/', { params: data,
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
	movementsActiveEquipments({ commit }) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/movements/get_movements_with_active_equipments/', {
				headers: {
					"Authorization": "Token " + localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data;
				resolve(data);
			})
			.catch(errors => {
				resolve(errors.response.data);
			});
		});
	},	
    movementStatusUpdate ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/movements/partial_update_status/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},

	//movement-types
	typeOverview ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/movement-types/', { params: data,
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				commit('set_movement_types', data)
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	typeDetail ({},data) {
		return new Promise((resolve, reject) => {
			session.get(`/api/workouts/movement-types/${data.id}/`, {
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	typeCreate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.post('api/workouts/movement-types/', data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	typeUpdate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.put(`/api/workouts/movement-types/${data.id}/`, data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	typeRemove ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/movement-types/partial_update_delete/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	filterTypes ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/movement-types/get_filtered_movement_types/', { params: data,
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
    typeStatusUpdate ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/movement-types/partial_update_status/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
}
  
// mutations
const mutations = {
	set_movements (state, movements) {
		state.all_movements = movements
	},
	set_movement_types (state, movement_types) {
		state.all_movement_types = movement_types
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
